import React from 'react';
import { classNames, flowClassNames, FlowClassNameProps } from './classNames';

export interface FormLabelProps extends React.LabelHTMLAttributes<HTMLLabelElement>, FlowClassNameProps {}

const FormLabel = React.forwardRef<HTMLLabelElement, FormLabelProps>(({
  className,
  children,
  display,
  flexGrow,
  overflowY,
  ...props
}, ref) => (
  <label
    ref={ref}
    className={classNames(
      'form-label',
      flowClassNames({
        display,
        flexGrow,
        overflowY,
      }),
      className,
    )}
    {...props}
  >
    {children}
  </label>
));

FormLabel.displayName = 'FormLabel';

export default FormLabel;
